import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import LivesTable from "../../../../../../Components/Broker/LivesTable/LivesTable";
import DatePickerDisable from "../../../../../../Supporting files/DatePickerDisable/DatePickerDisable";
import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import RKTextFieldDisable from "../../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SelectDropdownDisable from "../../../../../../Supporting files/SelectDropdownDisable/SelectDropdownDisable";
import UGEmailInput from "../../../../../../Supporting files/UGEmailInput/UGEmailInput";

function PolicyConfig({
  product_type,
}: {
  product_type?: "health" | "superTopup";
}) {
  // Variables start here
  const [cdBalance, setCdBalance] = React.useState("₹ 8,00,000");
  const [cdbalancepercentage, setCdBalancePercentage] = React.useState("10 %");
  const [enrollstartDate, setEnrollStartDate] = React.useState<Date | null>(
    new Date()
  );
  const [deductible, setDeductible] = React.useState("₹ 3,00,000");
  const [enrollendDate, setEnrollEndDate] = React.useState<Date | null>(
    new Date()
  );
  const [designations, setDesignations] = React.useState("");
  const [showhealth, setShowhealth] = useState(false);
  const [toggle, setToggle] = React.useState(true);
  const [showcorporate, setShowcorporate] = useState(false);
  const [planType, setPlanType] = React.useState(0);
  const [enrolmentPeriod, setEnrolmentPeriod] = React.useState("30 Days");
  const [gracePeriod, setGracePeriod] = React.useState("15Days");
  const [maximumMembers, setMaximumMembers] = React.useState("5");
  const [totalNumbers, setTotalNumbers] = React.useState("5");
  const [employeeenrollmentPeriod, setEmployeeEnrollmentPeriod] =
    React.useState("20Days");
  const [maximumNominee, setMaximumNominee] = React.useState("4");
  const [cardType, setCardType] = React.useState("E-Card");
  const [healthcardIssued, setHealthCardIssued] = React.useState(
    "Per Individual Member of the Family"
  );
  const [othersGraded, setOthersGraded] = React.useState("");
  const [gradedDesignation, setGradedDesignation] = React.useState("Salary");
  const [basicConfiguration, setBasicConfiguration] = React.useState("1E");
  const [indvConfiguration, setIndvConfiguration] = React.useState("1P");
  const [familyDefinition, setFamilyDefinition] = React.useState(
    "Employee, Spouse & 2 dependant Children up to the age of 25 years"
  );
  const [corporatebufferValue, setCorporateBufferValue] =
    React.useState("₹ 10,00,000");
  const [relatioshipLiveDetails, setRelatioshipLiveDetails] = useState(0);
  const [sumInsuredOne, setSumInsuredOne] = React.useState("₹3,00,000");
  const [sumInsured, setSumInsured] = React.useState("₹3,00,000");
  const [sumInsuredTwo, setSumInsuredTwo] = React.useState("₹ 25,00,000");
  const [gradeLives, setGradeLives] = React.useState("150");
  const [ageTableDetails, setAgeTableDetails] = useState(0);
  const [employeePayment, setEmployeePayment] = React.useState("%");
  const [spousePayment, setSpousePayment] = React.useState("%");
  const [childrenPayment, setChildrenPayment] = React.useState("%");
  const [parentsPayment, setParentsPayment] = React.useState("%");
  const [parentsinLawPayment, setParentsInLawPayment] = React.useState("%");
  const [show, setShow] = useState(false);
  //   Variables Ends here
  function toggleShow() {
    setShow(!show);
  }
  function toggleShowcorporate() {
    setShowcorporate(!showcorporate);
  }
  function toggleShowhealth() {
    setShowhealth(!showhealth);
  }
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName[0] === "rateData") {
    } else {
      let data: any = [...rateData];
      setRateData([...data]);
      if (attrName === "notes_new_data") {
        setNotesData((notesData) => [
          ...notesData,
          { name: "Umesh", date: new Date(), description: value },
        ]);
      } else {
        attrName(value);
      }
    }
  };

  const handleClickone = () => {
    setToggle(false);
  };
  const handleClicktwo = () => {
    setToggle(true);
  };

  const gradedDesignation_data = [
    { key: "Salary Bracket", value: "Salary Bracket" },
    { key: "Designation", value: "Designation" },
    { key: "Department", value: "Department" },
    { key: "Custom", value: "Custom" },
  ];
  const [rateData, setRateData] = React.useState([
    [
      { key: "one", value: "10" },
      { key: "two", value: "10" },
      { key: "three", value: "10" },
      { key: "four", value: "10" },
      { key: "five", value: "10" },
      { key: "six", value: "₹ 2368" },
    ],
  ]);
  const totalNumber_data = [
    { key: "4", value: "4" },
    { key: "6", value: "6" },
    { key: "5", value: "5" },
    { key: "7", value: "7" },
    { key: "3", value: "3 " },
  ];
  const maximumMember_data = [
    { key: "4", value: "4" },
    { key: "6", value: "6" },
    { key: "5", value: "5" },
    { key: "7", value: "7" },
    { key: "3", value: "3" },
  ];
  const gracePeriod_data = [
    { key: "5Days", value: "5 Days" },
    { key: "6Days", value: "6 Days" },
    { key: "7Days", value: "7 Days" },
    { key: "8Days", value: "8 Days" },
    { key: "9Days", value: "9 Days" },
    { key: "15Days", value: "15 Days" },
  ];
  const employeeEnrollmentPeriod_data = [
    { key: "15Days", value: "15 Days" },
    { key: "20Days", value: "20 Days" },
    { key: "45Days", value: "45 Days" },
    { key: "60Days", value: "60 Days" },
    { key: "90Days", value: "90 Days" },
  ];
  const maximumNominee_data = [
    { key: "4", value: "4" },
    { key: "3", value: "3" },
    { key: "2", value: "2" },
  ];
  const cardType_data = [
    { key: "E-Card", value: "E - Card" },
    { key: "Physical Card", value: "Physical Card" },
  ];
  const healthcardIssued_data = [
    {
      key: "Per Individual Member ofthe Family",
      value: "Per Individual Member of the Family",
    },
    { key: "Per Employee Only", value: "Per Employee Only" },
  ];
  const [ageData, setAgeData] = React.useState([
    [
      { key: "one", value: "10" },
      { key: "two", value: "10" },
      { key: "three", value: "10" },
      { key: "four", value: "10" },
      { key: "five", value: "10" },
      { key: "six", value: "10" },
      { key: "seven", value: "10" },
      { key: "eight", value: "10" },
      { key: "nine", value: "10" },
    ],
  ]);
  const basicConfig_data = [
    { key: "1E", value: "1E" },
    { key: "1E+1S", value: "1E + 1S" },
    { key: "1E+1S+1C", value: "1E + 1S + 1C" },
    { key: "1E+1S+1C+1C", value: "1E + 1S + 1C + 1C" },
  ];
  const indvConfig_data = [
    { key: "1P", value: "1P + 1P" },
    { key: "1PIL", value: "1PIL + 1PIL" },
    { key: "1P+1P+1PIL+1PIL", value: "1P + 1P + 1PIL + 1PIL" },
  ];
  const sumInsuredTwo_data = [
    { key: "₹3,00,000", value: "₹ 3,00,000" },
    { key: "₹4,00,000", value: "₹ 4,00,000" },
  ];
  const [livesinformationData, setLivesInformationData] = React.useState([
    {
      age_band: "Up to 1 - 18",
      total_lives: "50",
    },
    {
      age_band: "18 - 35",
      total_lives: "50",
    },
    {
      age_band: "35 - 45",
      total_lives: "50",
    },
    {
      age_band: "45 - 55",
      total_lives: "50",
    },
    {
      age_band: "55- 60",
      total_lives: "50",
    },
    {
      age_band: "60- 65",
      total_lives: "50",
    },
    {
      age_band: "65- 70",
      total_lives: "50",
    },
    {
      age_band: "70- 75",
      total_lives: "50",
    },
    {
      age_band: "75- 80",
      total_lives: "50",
    },
  ]);

  return (
    <div>
      <>
        <Box className="detailSection">
          <div className="sectionTitle">
            <h4>Plan Details</h4>
          </div>
          <Grid container spacing={3}>
            <Grid xs={4}>
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <h5 className="plan_type mb-0">Plan Type</h5>
                </Grid>
                <Grid xs={12}>
                  <Box className="plantTypeView">
                    <div className="select_plan_inner">
                      <h5>Graded Coverage</h5>
                      <p>
                        Different average amount for different employees in the
                        policy.
                      </p>
                    </div>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={8}>
              <Box className="coverageDetail">
                <Grid container spacing={3} className="px-0">
                  <Grid xs={12}>
                    <h5 className="empsecHeading">Coverage Type</h5>
                  </Grid>
                  <Grid xs={12}>
                    <Box className="coverageTypeView">
                      <Grid container spacing={3}>
                        <Grid xs={12} className="px-0">
                          <ul className="coverage_type_section ">
                            <li>
                              <div className="coverage_box employee">
                                <p>Employee</p>
                              </div>
                            </li>
                            <li>
                              <div className="coverage_box spouse">
                                <p>Spouse</p>
                              </div>
                            </li>
                          </ul>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid xs={12} className="px-0">
              {/* Coverage Section */}

              <Box className="coverageDetail">
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <h5 className="subHeading">Coverage Configuration</h5>
                  </Grid>

                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <SelectDropdownDisable
                      class_name="inputField"
                      title="Basic Configuration"
                      value={basicConfiguration}
                      attrName={setBasicConfiguration}
                      value_update={updateMasterState}
                      dropdown_data={basicConfig_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <SelectDropdownDisable
                      class_name="inputField"
                      title="Individual Configuration"
                      value={indvConfiguration}
                      attrName={setIndvConfiguration}
                      value_update={updateMasterState}
                      dropdown_data={indvConfig_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={12} md={8} lg={6} xl={4}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Family Definition"
                      value={familyDefinition}
                      attrName={setFamilyDefinition}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <h5 className="subHeading">Criterion for Grade Creation</h5>
                  </Grid>
                  <Grid sm={6} md={4} lg={3} xl={3}>
                    <SelectDropdownDisable
                      class_name="inputField"
                      title="Select Criteria"
                      value={gradedDesignation}
                      attrName={setGradedDesignation}
                      value_update={updateMasterState}
                      dropdown_data={gradedDesignation_data}
                      warn_status={false}
                    />
                  </Grid>
                  {/* {gradedDesignation === "Others" ? (
                    <Grid sm={6} md={4} lg={4} xl={3}>
                      <RKTextField
                        class_name="inputField"
                        title="Other - Input grade Criteria"
                        value={othersGraded}
                        attrName={setOthersGraded}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  ) : null} */}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* premium payment configuration start */}

        <Box className="detailSection">
          <div className="sectionTitle">
            <h4>Premium Payment Configuration</h4>
          </div>
          <div className="premium_payment_section">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <h5 className="subHeading">Premium Payment Type</h5>
              </Grid>
              <Grid xs={12} className="payment_radio_group">
                <>
                  <RadioGroup row defaultValue="new">
                    <FormControlLabel
                      value="existing"
                      control={<Radio />}
                      label="Standard Premium"
                      onClick={handleClickone}
                    />

                    <FormControlLabel
                      // checked
                      value="new"
                      control={<Radio />}
                      label="Split Premium"
                      onClick={handleClicktwo}
                    />
                  </RadioGroup>
                </>
              </Grid>
            </Grid>
            {toggle == true ? (
              <Grid container spacing={3}>
                <Grid sm={12} md={12} lg={6} xl={6}>
                  <div className="payment_inner_section">
                    <RKTextField
                      class_name="inputField"
                      title="Employee"
                      value={employeePayment}
                      attrName={setEmployeePayment}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                    <RKTextField
                      class_name="inputField"
                      title="Spouse"
                      value={spousePayment}
                      attrName={setSpousePayment}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                    <RKTextField
                      class_name="inputField"
                      title="Kids"
                      value={childrenPayment}
                      attrName={setChildrenPayment}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                    <RKTextField
                      class_name="inputField"
                      title="Parents"
                      value={parentsPayment}
                      attrName={setParentsPayment}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                    <RKTextField
                      class_name="inputField"
                      title="Parents In Law"
                      value={parentsinLawPayment}
                      attrName={setParentsInLawPayment}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </div>
                </Grid>
              </Grid>
            ) : null}
            <Grid container spacing={3}>
              <>
                {toggle == false ? (
                  <Grid xs={12} className="pt-0">
                    <h6>
                      100% of the premium value will be paid by the
                      Client/Employer
                    </h6>
                  </Grid>
                ) : null}

                {toggle == true ? (
                  <Grid xs={12} className="pt-0">
                    <h6>
                      Define % of the premium value to be paid by the employee
                      for the respective associated relationship
                    </h6>
                  </Grid>
                ) : null}
              </>
            </Grid>
          </div>
        </Box>
        {/* premium payment configuration end */}
        <Box className="detailSection">
          <div className="sectionTitle">
            <h4>Information on Grade Criterion</h4>
            <div className="total_lives">
              <p>
                400 <span>Total Lives</span>
              </p>
            </div>
          </div>
          <div className="policy_lives">
            <Grid container spacing={3}>
              {planType === 0 ? (
                <Grid sm={12} md={12} lg={8}>
                  <ul className="coverageAmt">
                    <li>
                      <div className="radioBox ">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(0)}
                        />
                        <label>Grade 1</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          defaultChecked
                          onClick={() => setAgeTableDetails(1)}
                        />
                        <label>Grade 2</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(2)}
                        />
                        <label>Grade 3</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(3)}
                        />
                        <label>Grade 4</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(4)}
                        />
                        <label>Grade 5</label>
                      </div>
                    </li>
                  </ul>
                </Grid>
              ) : null}
             
              <Grid sm={12} md={4} lg={4}>
                <SelectDropdownDisable
                  class_name="inputField"
                  title="Sum Insured"
                  value={sumInsuredTwo}
                  attrName={setSumInsuredTwo}
                  value_update={updateMasterState}
                  dropdown_data={sumInsuredTwo_data}
                  warn_status={false}
                />
              </Grid>
            </Grid>
            <Grid>
              <Grid xs={12} className="px-0">
                <UGEmailInput
                  class_name="inputField"
                  title="Designation"
                  value={designations}
                  attrName={setDesignations}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
            </Grid>
          </div>
        </Box>

        <Box className="detailSection">
          <div className="sectionTitle">
            <h4>Plan Settings</h4>
          </div>
          <Grid container spacing={3}>
            <Grid xs={4}>
              <RKTextFieldDisable
                class_name="inputField"
                title="Critical CD Balance Amount"
                value={cdBalance}
                attrName={setCdBalance}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <RKTextFieldDisable
                class_name="inputField"
                title="Critical CD Balance Amount"
                value={cdbalancepercentage}
                attrName={setCdBalancePercentage}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <DatePickerDisable
                class_name="inputField"
                title="Enrolment Start Date"
                value={enrollstartDate}
                attrName={setEnrollStartDate}
                value_update={updateMasterState}
                error_message="Please enter Enrolment Start Date"
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <DatePickerDisable
                class_name="inputField"
                title="Enrolment End Date"
                value={enrollendDate}
                attrName={setEnrollEndDate}
                value_update={updateMasterState}
                error_message="Please enter Enrolment Start Date"
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <RKTextFieldDisable
                class_name="inputField"
                title="Enrolment Peroid"
                value={enrolmentPeriod}
                attrName={setEnrolmentPeriod}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <SelectDropdownDisable
                class_name="inputField"
                title="Grace Peroid"
                value={gracePeriod}
                attrName={setGracePeriod}
                value_update={updateMasterState}
                dropdown_data={gracePeriod_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <SelectDropdownDisable
                class_name="inputField"
                title="Maximum Members per Family"
                value={maximumMembers}
                attrName={setMaximumMembers}
                value_update={updateMasterState}
                dropdown_data={maximumMember_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <SelectDropdownDisable
                class_name="inputField"
                title="Total Members per Family"
                value={totalNumbers}
                attrName={setTotalNumbers}
                value_update={updateMasterState}
                dropdown_data={totalNumber_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <SelectDropdownDisable
                class_name="inputField"
                title="New Employee Enrolment Period"
                value={employeeenrollmentPeriod}
                attrName={setEmployeeEnrollmentPeriod}
                value_update={updateMasterState}
                dropdown_data={employeeEnrollmentPeriod_data}
                warn_status={false}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid
              xs={6}
              className="switchFields"
              display={"flex"}
              alignItems="center"
              sx={{ height: "70px" }}
            >
              <span>Nomination</span>
              <input type="checkbox" className="switch" onClick={toggleShow} />

              {toggle == show ? (
                <div className="ml-2" style={{ width: "300px" }}>
                  <SelectDropdownDisable
                    class_name="inputField"
                    title="Maximum No. of Nominee"
                    value={maximumNominee}
                    attrName={setMaximumNominee}
                    value_update={updateMasterState}
                    dropdown_data={maximumNominee_data}
                    warn_status={false}
                  />
                </div>
              ) : null}
            </Grid>
            <Grid
              xs={6}
              className="switchFields"
              display={"flex"}
              alignItems="center"
              sx={{ height: "70px" }}
            >
              <span>Health Card</span>
              <input
                type="checkbox"
                className="switch"
                onClick={toggleShowhealth}
              />

              {toggle == showhealth ? (
                <div className="ml-2" style={{ width: "300px" }}>
                  <SelectDropdownDisable
                    class_name="inputField"
                    title="Card Type"
                    value={cardType}
                    attrName={setCardType}
                    value_update={updateMasterState}
                    dropdown_data={cardType_data}
                    warn_status={false}
                  />
                </div>
              ) : null}
            </Grid>
            <Grid xs={12} className="px-0">
              <Grid container spacing={3}>
                <Grid sm={12} md={8} lg={6}>
                  <SelectDropdownDisable
                    class_name="inputField"
                    title="Health Card Issued"
                    value={healthcardIssued}
                    attrName={setHealthCardIssued}
                    value_update={updateMasterState}
                    dropdown_data={healthcardIssued_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid
                  sm={12}
                  md={8}
                  lg={6}
                  className="switchFields"
                  display={"flex"}
                  alignItems="center"
                  sx={{ height: "70px" }}
                >
                  <span>Corporate Buffer</span>
                  <input
                    type="checkbox"
                    className="switch"
                    onClick={toggleShowcorporate}
                  />

                  {toggle == showcorporate ? (
                    <div className="ml-2" style={{ width: "250px" }}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title="Corporate Buffer Value"
                        value={corporatebufferValue}
                        attrName={setCorporateBufferValue}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </div>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box className="detailSection">
          <div className="sectionTitle">
            <h4>Relationship-Lives Information</h4>
            <div className="total_lives">
              <p>
                400 <span>Total Lives</span>
              </p>
            </div>
          </div>
          <div className="policy_lives">
            <Grid container spacing={3}>
              {planType === 0 ? (
                <Grid sm={12} md={12} lg={7}>
                  <ul className="coverageAmt">
                    <li>
                      <div className="radioBox ">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(0)}
                        />
                        <label>Grade 1</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          defaultChecked
                          onClick={() => setAgeTableDetails(1)}
                        />
                        <label>Grade 2</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(2)}
                        />
                        <label>Grade 3</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(3)}
                        />
                        <label>Grade 4</label>
                      </div>
                    </li>
                    <li>
                      <div className="radioBox">
                        <input
                          type="radio"
                          name="coveragesd"
                          onClick={() => setAgeTableDetails(4)}
                        />
                        <label>Grade 5</label>
                      </div>
                    </li>
                  </ul>
                </Grid>
              ) : null}
             
              {product_type === "superTopup" ? (
              <Grid sm={12} md={6} lg={3}>
                <div className="ml-3">
                  <RKTextField
                    class_name="inputField"
                    title="Deductible"
                    value={deductible}
                    attrName={setDeductible}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </div>
              </Grid>):null}
              <Grid sm={12} md={6} lg={2}>
                <SelectDropdownDisable
                  class_name="inputField"
                  title="Sum Insured"
                  value={sumInsuredTwo}
                  attrName={setSumInsuredTwo}
                  value_update={updateMasterState}
                  dropdown_data={sumInsuredTwo_data}
                  warn_status={false}
                />
              </Grid>
              {ageTableDetails === 0 ? (
                <Grid xs={12}>
                  <div className="table">
                    <div className="livesinformation-table">
                      <ul className="heading">
                        <li>Age Band (in years)</li>
                        <li>Employee</li>
                        <li>Spouse</li>
                        <li>Children</li>
                        <li>Parents</li>
                        <li>Parents-in-Law</li>
                        <li>
                          Premium Pricing for Addition/Deletion per Member
                        </li>
                        <li>Total Lives Count/Age Band</li>
                      </ul>

                      {livesinformationData.map((data, index) => (
                        <ul className="subheading">
                          <li>{data.age_band}</li>
                          {rateData.map((mainData, mainIndex) => (
                            <ul className="subheading">
                              {mainData.map((subData, subIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={subData.value}
                                    attrName={[
                                      "rateData",
                                      mainIndex,
                                      subIndex,
                                      subData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                          <li>{data.total_lives}</li>
                        </ul>
                      ))}
                    </div>
                  </div>
                </Grid>
              ) : null}

              {ageTableDetails === 1 ? (
                <Grid xs={12}>
                  <div className="table">
                    <div className="livesinformation-table">
                      <ul className="heading">
                        <li>Age Band (in years)</li>
                        <li>Employee</li>
                        <li>Spouse</li>
                        <li>Children</li>
                        <li>Parents</li>
                        <li>Parents-in-Law</li>
                        <li>Total Lives Count/Age Band</li>
                        <li>Premium Pricing for Addition/Deletion</li>
                      </ul>

                      {livesinformationData.map((data, index) => (
                        <ul className="subheading">
                          <li>{data.age_band}</li>
                          {rateData.map((mainData, mainIndex) => (
                            <ul className="subheading">
                              {mainData.map((subData, subIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={subData.value}
                                    attrName={[
                                      "rateData",
                                      mainIndex,
                                      subIndex,
                                      subData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                        </ul>
                      ))}
                    </div>
                  </div>
                </Grid>
              ) : null}

              {ageTableDetails === 2 ? (
                <Grid xs={12}>
                  <div className="table">
                    <div className="livesinformation-table">
                      <ul className="heading">
                        <li>Age Band (in years)</li>
                        <li>Employee</li>
                        <li>Spouse</li>
                        <li>Children</li>
                        <li>Parents</li>
                        <li>Parents-in-Law</li>
                        <li>Total Lives Count/Age Band</li>
                        <li>Premium Pricing for Addition/Deletion</li>
                      </ul>

                      {livesinformationData.map((data, index) => (
                        <ul className="subheading">
                          <li>{data.age_band}</li>
                          {rateData.map((mainData, mainIndex) => (
                            <ul className="subheading">
                              {mainData.map((subData, subIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={subData.value}
                                    attrName={[
                                      "rateData",
                                      mainIndex,
                                      subIndex,
                                      subData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                        </ul>
                      ))}
                    </div>
                  </div>
                </Grid>
              ) : null}

              {ageTableDetails === 3 ? (
                <Grid xs={12}>
                  <div className="table">
                    <div className="livesinformation-table">
                      <ul className="heading">
                        <li>Age Band (in years)</li>
                        <li>Employee</li>
                        <li>Spouse</li>
                        <li>Children</li>
                        <li>Parents</li>
                        <li>Parents-in-Law</li>
                        <li>Total Lives Count/Age Band</li>
                        <li>Premium Pricing for Addition/Deletion</li>
                      </ul>

                      {livesinformationData.map((data, index) => (
                        <ul className="subheading">
                          <li>{data.age_band}</li>
                          {rateData.map((mainData, mainIndex) => (
                            <ul className="subheading">
                              {mainData.map((subData, subIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={subData.value}
                                    attrName={[
                                      "rateData",
                                      mainIndex,
                                      subIndex,
                                      subData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                        </ul>
                      ))}
                    </div>
                  </div>
                </Grid>
              ) : null}

              {ageTableDetails === 4 ? (
                <Grid xs={12}>
                  <div className="table">
                    <div className="livesinformation-table">
                      <ul className="heading">
                        <li>Age Band (in years)</li>
                        <li>Employee</li>
                        <li>Spouse</li>
                        <li>Children</li>
                        <li>Parents</li>
                        <li>Parents-in-Law</li>
                        <li>Total Lives Count/Age Band</li>
                        <li>Premium Pricing for Addition/Deletion</li>
                      </ul>

                      {livesinformationData.map((data, index) => (
                        <ul className="subheading">
                          <li>{data.age_band}</li>
                          {rateData.map((mainData, mainIndex) => (
                            <ul className="subheading">
                              {mainData.map((subData, subIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={subData.value}
                                    attrName={[
                                      "rateData",
                                      mainIndex,
                                      subIndex,
                                      subData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                        </ul>
                      ))}
                    </div>
                  </div>
                </Grid>
              ) : null}
            </Grid>
          </div>
        </Box>
      </>
    </div>
  );
}

export default PolicyConfig;
